const CHANGE_PAGE = 'CHANGE_PAGE';

function changePage (query, nextPage) {
	return {
		type: CHANGE_PAGE,
		query,
		nextPage,
	};
}

const CHANGE_PAGE_LIMIT = 'CHANGE_PAGE_LIMIT';

function changePageLimit (query, newPageLimit) {
	return {
		type: CHANGE_PAGE_LIMIT,
		query,
		newPageLimit,
	};
}

const CHANGE_SORT = 'CHANGE_SORT';

function changeSort (query, newSortBy, newSortDirection, sortByResolver) {
	return {
		type: CHANGE_SORT,
		query,
		newSortBy,
		newSortDirection,
		sortByResolver,
	};
}

export default {
	CHANGE_PAGE,
	changePage,

	CHANGE_PAGE_LIMIT,
	changePageLimit,

	CHANGE_SORT,
	changeSort,
};
